(function () {
	const initPaymentMethods = () => {
		document.querySelectorAll('.product-payment-methods').forEach((details) => {
			const summary = details.querySelector('.product-payment-methods__toggle');
			const panel = details.querySelector('.product-payment-methods__panel');
			if (!summary || !panel || details.dataset.paymentMethodsInit === 'true') return;

			details.dataset.paymentMethodsInit = 'true';

			const props = {
				isAnimating: false,
				slideDuration: 400,
				slideEasing: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
			};

			summary.addEventListener('click', (event) => {
				event.preventDefault();
				if (props.isAnimating) return;

				if (!details.classList.contains('is-open')) {
					props.isAnimating = true;
					details.classList.add('is-open');
					details.setAttribute('open', '');
					panel.style.display = 'block';

					const animation = panel.animate(
						[
							{ height: '0px' },
							{ height: `${panel.scrollHeight}px` },
						],
						{
							duration: props.slideDuration,
							easing: props.slideEasing,
						}
					);

					animation.onfinish = () => {
						panel.style.height = '';
						props.isAnimating = false;
					};
				} else {
					props.isAnimating = true;
					details.classList.remove('is-open');

					const startHeight = panel.scrollHeight;
					const animation = panel.animate(
						[
							{ height: `${startHeight}px` },
							{ height: '0px' },
						],
						{
							duration: props.slideDuration,
							easing: props.slideEasing,
						}
					);

					animation.onfinish = () => {
						details.removeAttribute('open');
						panel.style.display = '';
						panel.style.height = '';
						props.isAnimating = false;
					};
				}
			});
		});
	};

	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};



	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup'); // Sticky bar
		const secondSection = document.querySelector('.product-section + section'); // Second section
		const footer = document.querySelector('footer'); // Footer

		// Check if the required elements exist
		if (!stickyBar || !secondSection || !footer) {
				console.error('Required elements not found!');
				return;
		}

			const getOffset = (element) => {
				const rect = element.getBoundingClientRect();
				return rect.top + window.scrollY;
			};

			const secondSectionMid = getOffset(secondSection);
			const footerTop = getOffset(footer);

			const handleScroll = () => {
				const scrollPosition = window.scrollY + window.innerHeight;
				const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop;

				stickyBar.classList[activeOffset ? "add" : "remove"]('active');
			};

			// Initial check in case the user starts in the middle of the page
			handleScroll();
};

	document.addEventListener('scroll', () => revealPopup());


	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initPaymentMethods();
		initZoomImage();
		revealPopup();
	});

	initProductAccordion();
	initPaymentMethods();
	initZoomImage();
	revealPopup();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const buyButtons = this.productElement.querySelector(".product__buy_buttons");

		if (buyButtons) {
			const notifyButton = buyButtons.querySelector(".notify-button");
			if (notifyButton) notifyButton.remove();

			const paymentMethods = buyButtons.querySelector(".product-payment-methods");
			if (paymentMethods) paymentMethods.remove();

			this.productElement.innerHTML = "";
			this.productElement.appendChild(buyButtons);
			return;
		}

		this.productElement.innerHTML = "";
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);
